<template>
  <div>
    <pdf :src="this.pdfFile" :page="1">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="2">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="3">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="4">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="5">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="6">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="7">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="8">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="9">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="10">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="11">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="12">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="13">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="14">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="15">
      <template slot="loading"> loading content here... </template>
    </pdf>
    <pdf :src="this.pdfFile" :page="16">
      <template slot="loading"> loading content here... </template>
    </pdf>
  </div>
</template>
<script>
import pdf from "pdfvuer";

export default {
  name: "SculpturesPdf",
  components: {
    pdf,
  },
  data() {
    return {
      pdfFile: "/pdf/Emanuele Viscuso's sculptures Catalog.pdf",
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
